<template>

  <unauthed-panel :title="$t('titles.page_not_found')">

    <p class="text-center text-h5 mb-12">{{ $t('alerts.page_not_found_explanation') }}</p>

    <p class="text-center"><router-link :to="{name: 'login'}">{{ $t('actions.go_home') }}</router-link></p>

  </unauthed-panel>

</template>

<script setup lang="ts">

import { useTitle } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

import UnauthedPanel from '../UnauthedPanel.vue'

const { t } = useI18n()
const title = useTitle()

title.value = t('titles.page_not_found')

</script>
